import { jsx as _jsx } from "react/jsx-runtime";
import { CatChip } from '@blocks-react/components/Chip';
import styles from '../NotificationDrawer.module.scss';
export const NotificationChips = ({ notificationChip = '', handleRemovingChip }) => {
    return (_jsx(CatChip, { className: "d-inline-block mb-1 mr-1", onBlChipRemove: () => handleRemovingChip(notificationChip), removable: true, "data-testid": "order-status-chip", children: _jsx("div", { className: styles['notificationchip_ellipsis'], children: notificationChip }) }, notificationChip));
};
